import Layout from '../global/Layout';
import NotificationMessage from '@solid/shared/ui/NotificationMessage';
import * as Styled from './NewCheckPage.styles';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CheckNotFound = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div style={{ maxWidth: '300px', margin: '0 auto' }}>
        <NotificationMessage state='danger'>{t('checks.common.checkNotFound')}</NotificationMessage>
      </div>
      <Styled.BtnContainer>
        <Link className='btn is-primary is-outlined' to='/'>
          {t('common.back')}
        </Link>
      </Styled.BtnContainer>
    </Layout>
  );
};

export default CheckNotFound;
